import * as React from 'react'

import { spacing, Text } from 'main/ui'
import { palette } from '../constants'
import RangeSlider, { IRangeProps } from './RangeSlider'
import { formatTimeFromMinutes } from './util'

interface IProps {
  minValue: number
  maxValue: number
  step?: number
  value: IRangeProps
  onChange: (value: IRangeProps) => void
}

export default function TimeRangeSlider(props: IProps) {
  const { minValue, maxValue, step = 15, value, onChange } = props

  validateMinMax(minValue, maxValue)

  return (
    <div>
      <RangeLabel value={value} />
      <div
        style={{
          marginTop: `${spacing.majorScale(2)}px`,
          marginBottom: `${spacing.majorScale(2)}px`,
          marginLeft: `${spacing.minorScale(1)}px`,
          marginRight: `${spacing.minorScale(-4)}px`,
        }}
      >
        <RangeSlider
          range={{ min: minValue, max: maxValue }}
          step={step}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  )
}

const RangeLabel = (props: { value: IRangeProps }) => {
  const {
    value: { min, max },
  } = props

  return (
    <Text style={{ color: palette.black }}>
      {formatTimeFromMinutes(min)} - {formatTimeFromMinutes(max)}
    </Text>
  )
}

function validateMinMax(min: number, max: number) {
  if (min < 0 || max >= 1440) {
    throw new Error('Min and max values should be greater than or equal to 0 and less than 1440.')
  }
}
